import { EmptyChat } from '@/assets/icons/ats/empty';
import { CenterSpinner, EmptyResults } from '@/components/ats';
import { Box, Button, Flex } from '@chakra-ui/react';
import { useEffect, useRef, useCallback } from 'react';
import { NewNote } from './NewNote';
import { Note } from './Note';

export const NotesWrapper = ({
  isLoading = false,
  notes = [],
  handleNoteAdd = () => {},
  handleNoteAccessChange = () => {},
  handleNoteUpdate = () => {},
  isUpdating = false,
  meta = {},
  onLoadMore = () => {},
  isMoreLoading = false,
  type,
  transferInfo = null,
}) => {
  const scrollContainerRef = useRef(null);
  const noteEndRef = useRef(null);

  const scrollToBottom = useCallback(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        top: scrollContainerRef.current.scrollHeight,
        behavior: 'smooth',
      });
    }
  }, []);

  useEffect(() => {
    if (isLoading) return;
    // Only scroll if there are notes to show (on initial load completion)
    if (notes.length > 0) {
      // Use setTimeout to ensure DOM is fully rendered
      setTimeout(() => {
        scrollToBottom();
      }, 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  if (isLoading) return <CenterSpinner />;

  return (
    <Flex
      flex="1"
      h="100%"
      maxH="100%"
      flexDir="column"
      justifyContent="space-between"
      overflow="hidden"
    >
      <Flex
        ref={scrollContainerRef}
        p="24px"
        flex="1"
        overflowY="auto"
        flexDir="column"
        gap="10px"
        minH="0"
      >
        {!notes.length && (
          <EmptyResults
            icon={EmptyChat}
            subText="NO NOTES YET"
            text="Add a note about this candidate"
            iconProps={{ width: '140px', height: '140px', mb: '12px' }}
          />
        )}

        {(meta?.count > notes?.length || meta?.page < meta?.pages) &&
          (isMoreLoading ? (
            <CenterSpinner h="40px" />
          ) : (
            <Button variant="tertiary" onClick={onLoadMore}>
              Load more
            </Button>
          ))}
        {notes?.map((note) => (
          <Note
            key={note?.id}
            note={note}
            handleNoteAccessChange={handleNoteAccessChange}
            handleNoteUpdate={handleNoteUpdate}
            isUpdating={isUpdating}
            type={type}
            transferInfo={transferInfo}
          />
        ))}
        <Box ref={noteEndRef} h="1px" visibility="hidden" />
      </Flex>
      <NewNote
        handleNoteAdd={handleNoteAdd}
        scrollToBottom={scrollToBottom}
        type={type}
      />
    </Flex>
  );
};
